import { Component, HostListener, OnInit } from '@angular/core';
import { GlobalClassInstance } from '@commoncore/constants/GlobalClass';
import { TOAST } from '@commoncore/constants/ToastMessages';
import { FileInfoController } from '@commoncore/controller/FileInfoController';
import { FileInfoImplementation } from '@commoncore/implementation/FileInfoImplementation';
import { GlobalService } from '@commoncore/services/global.service';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { DependenciesModule } from '@modules/dependencies/dependencies.module';
@Component({
  standalone:true,
  selector: 'lib-file-info-comments',
  templateUrl: './file-info-comments.component.html',
  styleUrls: ['./file-info-comments.component.scss'],
  imports:[DependenciesModule]
})
export class FileInfoCommentsComponent implements OnInit {
  public universalService:any;
  fileInfoController: any;
  fileInfoImpl: any;
  textToAppend:any = "ago"
  isAllowedToComment:boolean;
  isCommentLoaded:boolean = false;
  isCommentAdded:boolean = true;
  userComment:any = '';

  public constructor(public globalService:GlobalService) {
    this.fileInfoImpl = new FileInfoImplementation(globalService);
    this.universalService = globalService.getUniversalServiceRef();
  }

  @HostListener('document:keydown', ['$event'])
  onKeyDownHandler(event: KeyboardEvent) {
    if(event.key === "Enter"){
      var inputElement = document.getElementById('comment-input-box');
      if((inputElement == document.activeElement) && this.userComment != '' && this.isCommentAdded == true) {
        this.addFileInfoComment();
      }
    }
  }

  ngOnInit(): void {
    this.fileInfoController = FileInfoController.getInstance(this.globalService);
    this.fileInfoController.setEnvObjects(this.globalService);
    this.universalService.finalLastUpdatedDateOfResponse = 0;
    if(window.location.href.includes("teamfolders") || this.universalService.selectedFile["tfKey"]){
      this.checkAccessToCommentForTF();
    } else {
      this.checkAccessToComment();
    }
    
    this.getComments();
    this.setInfoCommentHeight();
  }

  checkAccessToComment() {
    if(this.universalService.selectedFile.shareKey != undefined) {
      if(this.universalService.selectedFile.recipientsObjRights && this.universalService.selectedFile.recipientsObjRights.canComment == true && 
        this.universalService.selectedFile.isShared) { //New requirement, if there is no members then post comment should be disabled or hidden
        this.isAllowedToComment = true;
      } else {
        this.isAllowedToComment = false;
      }
    } else {
      this.isAllowedToComment = true;
    }
  }

  checkAccessToCommentForTF() {
    if(this.universalService.selectedFile.userRight != undefined) {
      if(this.universalService.selectedFile.userRight.canComment == true ) {
        this.isAllowedToComment = true;
      } else {
        this.isAllowedToComment = false;
      }
    } else {
      this.isAllowedToComment = true;
    }
  }

  getProfileImageUrl() {
    return 'url('+this.universalService.profileIconPath+')';
  }

  attachKeysToPhoto(photoPath) {
    if(photoPath){
      let type = this.universalService.checkIfImgTypeParamIsRequired("");
      return 'url('+photoPath + '&apiKey=' + ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]['X-Api-Key'] + type +')';
    }
  }

  setInfoCommentHeight(){
    let header_ele = document.getElementById('desk-info-header');
    let img_ele = document.getElementById('desk-info-img-wrapper');
    let info_cont = (document.querySelector('.file-info-scrollable')) as any;
    let nav_height = document.querySelector('.slidemenu-file-info') as any;
    let height;
    if(this.universalService.isMobileDevice) {
      height = (window.innerHeight- (header_ele.offsetHeight + nav_height.offsetHeight + 70)).toString() + 'px';
    } else {
      height = (window.innerHeight- (header_ele.offsetHeight + img_ele.offsetHeight + (nav_height ? nav_height.offsetHeight + 10 : 0) + 70)).toString() + 'px';
    }    
    info_cont.style.height = height
  }

  onScrollDown(event){
    var docheight = document.querySelector('.comments-tab-content').scrollHeight;
    var toppos =  $(".commentsScrollableContainer").scrollTop();
    if ((toppos + $(".commentsScrollableContainer").innerHeight()) >= (0.95 * docheight) && 
      this.fileInfoImpl.isDataOfScrollLoaded == true &&
      this.fileInfoImpl.isNextPageAvailable == true && this.universalService.finalLastUpdatedDateOfResponse > 0) {
      //call http and append data
      this.getComments();
    }
  }

  async getComments() {
    this.fileInfoImpl.isDataOfScrollLoaded = false;
    this.fileInfoImpl.toggleSmallLoader(true);
    var commentData = await this.fileInfoController.getCommentsInFileInfo(this.universalService.selectedFile);
    if((commentData != undefined ||  commentData != null)&& commentData["comments"]) {
      this.fileInfoImpl.currentTimeToUse = new Date().getTime();
      Array.prototype.push.apply(this.fileInfoImpl.fileInfoCommentsData, commentData["comments"]);
      // If got comments of page limit 
      if(commentData["comments"].length == this.fileInfoImpl.defaultPageLimit) {
        var lastUpdateDateOfRecord = commentData["comments"][commentData["comments"].length-1]["lastUpdatedDate"];
        this.universalService.finalLastUpdatedDateOfResponse = lastUpdateDateOfRecord;
        this.fileInfoImpl.isNextPageAvailable = true;
        this.fileInfoImpl.isDataOfScrollLoaded = true;
      } else {
        this.universalService.finalLastUpdatedDateOfResponse = 0;
        this.fileInfoImpl.isNextPageAvailable = false;
        this.fileInfoImpl.isDataOfScrollLoaded = true;
      }
    } else {
      //this.universalService.showToast(TOAST["GENERIC_ERROR"],"error");
      this.universalService.showLoader = false;
    }
    this.fileInfoImpl.toggleSmallLoader(false);
    this.isCommentLoaded = true;
  }

  async deleteFileInfoComment(commentKey, index) {
    if(commentKey && commentKey != '') {
      this.fileInfoImpl.toggleSmallLoader(true);
      var deleteResult = await this.fileInfoController.deleteFileInfoComment(this.universalService.selectedFile, commentKey);
      if(deleteResult == "SUCCESS") {
        $("#comment-row-" + index).children("div:first").remove();
        this.fileInfoImpl.fileInfoCommentsData.splice(index,1); // remove from array
        this.fileInfoImpl.toggleSmallLoader(false);
      } else {
        // if delete comment failed
        this.fileInfoImpl.toggleSmallLoader(false);
        this.universalService.showToast(TOAST["GENERIC_ERROR"], "error")
        return;
      }
    }

  }

  async addFileInfoComment() {
    var commentData = $("#comment-input-box").val();
    if(commentData && commentData != '') {
      this.isCommentAdded = false;
      this.fileInfoImpl.toggleSmallLoader(true);
      var addResult = await this.fileInfoController.addFileInfoComment(this.universalService.selectedFile, commentData);
      if((addResult != undefined ||  addResult != null)&& addResult["comments"]) {
        this.fileInfoImpl.currentTimeToUse = new Date().getTime();
        this.fileInfoImpl.fileInfoCommentsData = addResult["comments"];
        $("#comment-input-box").val('');
        this.userComment = '';
      } else {
        this.universalService.showToast(TOAST["GENERIC_ERROR"],"error");
        this.universalService.showLoader = false;
      }
      this.fileInfoImpl.toggleSmallLoader(false);
      this.isCommentAdded = true;
    }
  }
}
